import React from 'react'
import ContactUsComponents from '../../components/ContacUsComponents/ContactUsComponents'

const Contactus = () => {
    return (
        <>
            <ContactUsComponents />
        </>
    )
}

export default Contactus
